import React, { useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import useTranslator from "../../../hooks/useTranslator";
import KgGreen from "../../../images/kg_green.svg";
import Box from "../../../images/boxes.svg";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const ReworkDashboard = () => {
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);

  const listItems = [
    {
      label: _t("rework_total_kg", "Total KG in Rework"),
      value: 0,
      icon: KgGreen,
    },
    {
      label: _t("rework_total_cases", "Total Cases in Rework"),
      value: 0,
      icon: Box,
    },
    {
      label: _t("rework_processed_kg", "Processed KG"),
      value: 0,
      icon: KgGreen,
    },
    {
      label: _t("rework_pending_kg", "Pending KG"),
      value: 0,
      icon: KgGreen,
    },
  ];

  return (
    <div>
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("rework_overview_title", "Rework Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("common_today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ReworkDashboard;
